/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `planned` - Zaplanowany
 * * `active` - Aktywny
 * * `finished` - Zakończony
 */
export type ChallengeStateEnum = typeof ChallengeStateEnum[keyof typeof ChallengeStateEnum];


export const ChallengeStateEnum = {
  planned: 'planned',
  active: 'active',
  finished: 'finished',
} as const;
